/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { ProfileSection } from './ProfileSection';
import { PermissionsSection } from './PermissionsSection';
import { PortalsSection } from './PortalsSection';
import { TeamScreen } from './TeamScreen/TeamScreen';
import { SaleSettingsSection } from './SaleSettingsSection';
import { LeaseSettingsSection } from './LeaseSettingsSection';
import { PropertySettingsSection } from './PropertySettingsSection';
import { FacebookSettingsSection } from './FacebookSettingsSection';
import { SubscriptionSettingsPage } from '@features/subscription/pages/SubscriptionSettingsPage';
import type { SettingsSection } from '../constants/settings-nav';
import type { ItemSectionProps } from './SettingsItemList';

const SECTION_COMPONENTS: Record<SettingsSection, React.ComponentType<ItemSectionProps>> = {
  perfil: ProfileSection,
  equipe: TeamScreen,
  permissoes: PermissionsSection,
  plano: SubscriptionSettingsPage,
  portais: PortalsSection,
  facebook: FacebookSettingsSection,
  vendas: SaleSettingsSection,
  locacoes: LeaseSettingsSection,
  imoveis: PropertySettingsSection,
};

/**
 * Renders the component that corresponds to the active settings section.
 * @param props - Component props.
 * @param props.active - The currently selected settings section key.
 * @param props.item - The setting open inside it, for the tabs that list settings.
 * @param props.onOpenItem - Opens one of those settings.
 * @returns The matching settings section element.
 */
export function SettingsSectionContent({ active, item, onOpenItem }: { active: SettingsSection } & ItemSectionProps) {
  const Section = SECTION_COMPONENTS[active];
  return <Section item={item} onOpenItem={onOpenItem} />;
}
